module.exports = __webpack_public_path__ + "static/media/Brunnen_tn.e1dc342c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Brunnen_tn.jpg
// module id = 758
// module chunks = 0